import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import TextInput from "component/common/TextInput/index";
import TextField from "component/common/TextField/index";
import RadioButton from "component/common/RadioButton/index";
import ImageSlider from "component/common/ImageSlider/index";
import { useForm } from "react-hook-form";
import ErrorMessage from "component/common/ErrroMessage/index";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import Select from "component/common/Select";
import MultiLevelSelect from "component/common/MultiLevelSelect";
import CustomSelect from "component/common/CustomSelect";
import { getDonationById, updateDonation } from "service/Donation";
import {
  getAllCategory,
  multipleImageUpload,
  singleImageUpload,
} from "service/Common";
import { fileType } from "utils/helper";
import Moment from "react-moment";
import ProductMedia from "component/common/ProductMedia";
import { Toast } from "utils/toast";
import usePopup from "hooks/usePopUp";
import arrow from "assets/images/arrow.svg";

import styles from "./EditDonation.module.scss";

const EditDonation = () => {
  const { id } = useParams();

  const history = useHistory();

  const { successPopUp, togglePopUp, setMsg } = usePopup();

  const {
    handleSubmit,
    getValues,
    register,
    formState: { errors },
  } = useForm();

  let [statusOption, setStatusOptions] = useState([]);

  const conditionOption = [
    "Brand New / Unused",
    "Brand New / Used",
    "Gently Used",
    "Used",
  ];

  const warrantyRadio = [
    {
      label: "Yes",
      name: "warranty",
      value: "1",
    },
    {
      label: "No",
      name: "warranty",
      value: "0",
    },
  ];

  const genderOptions = ["Boys", "Girls", "Unisex"];

  const metricOptions = ["Grams", "KG"];

  let [radio, setRadio] = useState({
    warranty: "",
  });

  let [status, setStatus] = useState();

  let [selectedCategory, setSelectedCategory] = useState();

  let [condition, setCondition] = useState();

  let [category, setCategory] = useState(null);

  let [donation, setDonation] = useState(null);

  let [image, setImage] = useState(null);

  let [state, setState] = useState();

  let [media, setMedia] = useState(false);

  let [gender, setGender] = useState(null);

  let [metric, setMetric] = useState(null);

  useEffect(() => {
    getCategory();
    getDonation();
    setMsg("Donation details has been updated successfully");
    let inputTypeNumbers = document.querySelectorAll("input[type=number]");
    for (let a = 0; a < inputTypeNumbers.length; a++) {
      inputTypeNumbers[a].onwheel = function (event) {
        event.target.blur();
      };
    }
  }, []);

  const getDonation = async () => {
    try {
      let response = await getDonationById(id);
      if (response.status === 200) {
        let radioValue = {
          ...radio,
          warranty: response.data.data[0].warranty === 1 ? "1" : "0",
        };
        setStatus(response.data.data[0].productStatus);
        setImage(response.data.data[0].imageUrl);
        setCondition(response.data.data[0].productConditon);
        setSelectedCategory(response.data.data[0].categoryInfo);
        setRadio(radioValue);
        setGender(response.data.data[0].gender);
        setMetric(response.data.data[0].productWeightMetrics);
        setDonation(response.data.data[0]);
        let initialStatus = ["Accepted, on sale"];
        let finalStatus = [
          "Payment Initiated",
          "Payment Complete",
          "Dispute Raised",
        ];
        setStatusOptions(
          response.data.data[0].productStatus == "Product Delievered"
            ? finalStatus
            : initialStatus
        );
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const getCategory = async () => {
    try {
      let response = await getAllCategory();
      if (response.status == 200) {
        setCategory(response.data.data);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const onSubmit = async (data) => {
    let body = {
      _id: id,
      productTitle: data.productTitle,
      brand: data.brand,
      size: data.size,
      chooseType: "donation",
      originalPrice: data.originalPrice,
      salePrice: data.salePrice,
      deliveryCharges: data.deliveryCharge,
      originalDateofPurchase: data?.originalDateofPurchase,
      productCondition: condition,
      productCategory: selectedCategory._id,
      productDamage: data.productDamage,
      approxWeight: data.approxWeight,
      productDescription: data.productDescription,
      imageUrl: image,
      gender: gender,
      notes: data.notes,
      productWeightMetrics: metric,
      productStatus: status,
      categoryId: selectedCategory._id,
      warranty: Number(radio.warranty),
      warrantyPeriod: data.warrantyPeriod,
      sellerDetails: {
        sellerName: data.sellerName,
        sellerAddress: data.sellerAddress,
        mobileNo: data.sellerPhone,
        email: data.sellerEmail,
      },
    };
    try {
      let response = await updateDonation(body);
      if (response.status == 200) {
        togglePopUp();
        setTimeout(() => {
          history.goBack();
        }, 2000);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handleRadio = (event) => {
    const { name, value } = event;
    let data = { ...radio, [name]: value };
    setRadio(data);
  };

  const addImage = async (event) => {
    let formData = new FormData();
    for (let index = 0; index < event.target.files.length; index++) {
      const file = event.target.files[index];
      formData.append("file", file);
    }
    let img = image;
    try {
      let response = await multipleImageUpload(formData);
      if (response.status == 200) {
        response.data.data.map((item) => {
          img.push(item.url);
        });
        let images = img.filter((url) => {
          return fileType(url) != "mp4";
        });
        let videos = img.filter((url) => {
          return fileType(url) == "mp4";
        });
        setImage(images.concat(videos));
        setState(Math.random());
        Toast({
          type: "success",
          message: "Image has been added successfully",
        });
      }
    } catch (error) {
      Toast({ type: error, message: error.data.message });
    }
  };

  const deleteImage = (index) => {
    let img = image;
    img.splice(index, 1);
    setImage(img);
    setState(Math.random());
  };

  const updateImage = async (event, index) => {
    event.persist();
    let formData = new FormData();
    const file = event.target.files[0];
    formData.append("file", file);
    let img = image;
    try {
      let response = await singleImageUpload(formData);
      if (response.status == 200) {
        img[index] = response.data.data.url;
        setImage(img);
        setState(Math.random());
        Toast({
          type: "success",
          message: "Image has been updated successfully",
        });
      }
    } catch (error) {
      Toast({ type: error, message: error.data.message });
    }
  };

  const toggleMedia = () => {
    setMedia(!media);
  };

  const handleRefresh = () => {
    getDonation();
  }

  if (donation == null) return null;

  return (
    <>
      <div className={styles.donation_detail}>
        <div className={styles.title}>
          <img
            src={arrow}
            className="back-arrow"
            onClick={() => history.goBack()}
          />
          <b>EDIT DONATION</b>
        </div>
        <div className={styles.donation_status}>
          <label>
            Item Code :
            <span className={styles.item_code}>{donation?.itemNo}</span>
          </label>
          <label>Status :</label>
          <div style={{ width: "200px" }}>
            <Select
              options={statusOption}
              color="#979797"
              name="productStatus"
              value={status}
              onChange={(e) => setStatus(e.value)}
            />
          </div>
          <SaveCancelBtn
            onSave={handleSubmit(onSubmit)}
            onCancel={() => history.goBack()}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <ImageSlider
            url={image}
            next="image-next"
            prev="image-prev"
            toggle={toggleMedia}
          />
        </div>
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-3  mb-4">
              <TextInput
                label="Product Title"
                register={register("productTitle", { required: true })}
                error={errors.productTitle}
                value={donation?.productTitle}
              />
              <ErrorMessage
                error={errors.productTitle}
                message={{ required: "Please enter product title" }}
              />
            </div>
            <div className="col-md-3 mb-4">
              <MultiLevelSelect
                label="Category"
                name="productCategory"
                onChange={(e) => setSelectedCategory(e)}
                value={selectedCategory.categoryName}
                options={category}
              />
            </div>
            <div className="col-md-3 mb-4">
              <TextInput
                label="Brand"
                register={register("brand", { required: true })}
                error={errors.brand}
                value={donation?.brand}
              />
              <ErrorMessage
                error={errors.brand}
                message={{ required: "Please enter brand" }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Size / Capacity"
                register={register("size", { required: true })}
                error={errors.size}
                value={donation?.size}
              />
              <ErrorMessage
                error={errors.size}
                message={{ required: "Please enter size / capacity" }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <CustomSelect
                label="Product Condition"
                value={condition}
                options={conditionOption}
                onChange={(e) => setCondition(e.value)}
              />
            </div>
            <div className="col-md-3 mb-4">
              <CustomSelect
                label="Gender"
                value={gender}
                options={genderOptions}
                onChange={(e) => setGender(e.value)}
              />
            </div>
            <div className="col-md-3 mb-4">
              <TextInput
                type="number"
                label="Approximate Weight"
                placeholder="Weight"
                register={register("approxWeight", {
                  required: true,
                  valueAsNumber: true,
                  setValueAs: (v) => parseInt(v),
                })}
                value={donation.approxWeight}
                error={errors.approxWeight}
              />
              <ErrorMessage
                error={errors.approxWeight}
                message={{
                  required: "Please enter approximate weight",
                }}
              />
            </div>
            <div className="col-md-3 mb-4">
              <CustomSelect
                label="Metric"
                value={metric}
                options={metricOptions}
                onChange={(e) => setMetric(e.value)}
              />
            </div>
            <div className="col-md-3 mb-4">
              <TextInput
                label="Original Date of Purchase"
                register={register("originalDateofPurchase", {
                  required: true,
                })}
                type="date"
                max={new Date().toISOString().split("T")[0]}
                value={String(donation?.originalDateofPurchase).substr(0, 10)}
                error={errors.originalDateofPurchase}
              />
              <ErrorMessage
                error={errors.originalDateofPurchase}
                message={{ required: "Please enter date of purchase" }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Date of Product Resale"
                type="text"
                value={
                  donation?.statusDate?.acceptedOnSale
                    ? donation?.statusDate?.acceptedOnSale
                    : "None"
                }
                disabled={true}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Product Age"
                error={errors.productAge}
                disabled={true}
                value={
                  <Moment fromNow ago>
                    {donation.originalDateofPurchase}
                  </Moment>
                }
              />
            </div>
            <div className="col-md-3 mb-4">
              <TextInput
                label="Original Price"
                register={register("originalPrice", {
                  required: true,
                  setValueAs: (v) => parseInt(v),
                  valueAsNumber: true,
                  pattern: /^[0-9]*\.?[0-9]*$/,
                })}
                type="number"
                error={errors.originalPrice}
                value={donation?.originalPrice}
              />
              <ErrorMessage
                error={errors.originalPrice}
                message={{
                  required: "Please enter original price",
                  pattern: "Original Price contains number only",
                }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Sale / Listing Price"
                register={register("salePrice", {
                  required: true,
                  setValueAs: (v) => parseInt(v),
                  validate: () =>
                    getValues("salePrice") < getValues("originalPrice"),
                  pattern: /^[0-9]*\.?[0-9]*$/,
                  valueAsNumber: true,
                })}
                type="number"
                error={errors.salePrice}
                value={donation?.salePrice}
              />
              <ErrorMessage
                error={errors.salePrice}
                message={{
                  required: "Please enter listing price",
                  pattern: "Sale Price contains number only",
                  validate: "Sale price must be less than original price",
                }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Delivery Charge"
                register={register("deliveryCharge", {
                  required: true,
                  setValueAs: (v) => parseInt(v),
                  pattern: /^[0-9]*\.?[0-9]*$/,
                  valueAsNumber: true,
                })}
                type="number"
                error={errors.deliveryCharge}
                value={donation?.deliveryCharges}
              />
              <ErrorMessage
                error={errors.deliveryCharge}
                message={{
                  required: "Please enter delivery charge",
                  pattern: "Delivery charge contains number only",
                }}
              />
            </div>
            <div className="col-md-3  mb-4">
              <label
                style={{
                  color: "#979797",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Warranty Available
              </label>
              <div className={styles.radio_btn}>
                {warrantyRadio.map((list, index) => {
                  return (
                    <RadioButton
                      key={index}
                      label={list.label}
                      name={list.name}
                      value={list.value}
                      isChecked={radio.warranty === list.value ? true : false}
                      onChange={handleRadio}
                    />
                  );
                })}
              </div>
            </div>
            {radio.warranty === "1" && (
              <div className="col-md-3 mb-4">
                <TextInput
                  label="Warranty Valid Till"
                  register={register("warrantyPeriod", { required: true })}
                  error={errors.warrantyPeriod}
                  value={String(donation?.warrantyPeriod).substr(0, 10)}
                  type="date"
                />
                <ErrorMessage
                  error={errors.warrantyPeriod}
                  message={{ required: "Please enter warranty valid till" }}
                />
              </div>
            )}
            <div className="col-md-12 mb-4">
              <TextField
                label="Product Description"
                register={register("productDescription", { required: true })}
                error={errors.productDescription}
                value={donation?.productDescription}
              />
              <ErrorMessage
                error={errors.productDescription}
                message={{ required: "Please enter product description" }}
              />
            </div>
            <div className="col-md-12  mb-4">
              <TextField
                label="Product Damages (if any)"
                register={register("productDamage")}
                error={errors.productDamage}
                height={50}
                value={donation?.productDamage}
              />
              <ErrorMessage
                error={errors.productDamage}
                message={{ required: "Please enter product damage" }}
              />
            </div>
            <div className="col-md-12 mb-4">
              <TextField
                label="Notes"
                register={register("notes", { required: false })}
                value={donation.notes}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>SELLER DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3 mb-4">
          <TextInput
            label="Seller Name"
            value=""
            register={register("sellerName", {
              required: true,
              pattern: /^[A-Za-z ]+$/,
              minLength: 3,
            })}
            error={errors.sellerName}
          />
          <ErrorMessage
            error={errors.sellerName}
            message={{
              required: "Please enter staff name",
              minLength: "Staff name contain atleast 3 characters",
              pattern: "Staff name contain string only",
            }}
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Seller Email ID"
            value=""
            register={register("sellerEmail", {
              required: true,
              pattern:
                /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
            })}
            error={errors.sellerEmail}
          />
          <ErrorMessage
            error={errors.sellerEmail}
            message={{
              required: "Please enter email",
              pattern: "Invalid email",
            }}
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Seller Phone Number"
            value=""
            register={register("sellerPhone", {
              required: true,
              pattern: /^[0-9]{10}$/,
            })}
            error={errors.sellerPhone}
          />
          <ErrorMessage
            error={errors.sellerPhone}
            message={{
              required: "Please enter seller phone number",
              pattern: "Phone number contain 10 numbers only",
            }}
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextField
            label="Seller Address"
            value=""
            register={register("sellerAddress", { required: true })}
            error={errors.sellerAddress}
          />
          <ErrorMessage
            error={errors.sellerAddress}
            message={{
              required: "Please enter seller address",
            }}
          />
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>BUYER DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3  mb-4">
          <TextInput label="Buyer Name" value="Deepa Jain" disabled={true} />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Buyer Instagram Handle"
            value="deepa.jain@gmail.com"
            disabled={true}
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Buyer Phone Number"
            value="9719763290"
            disabled={true}
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextField
            label="Buyer Address"
            value="2112, Sobha Malachite,  Jakkur Main Road, Yelahanka, Bengaluru , Karnataka, 560064"
            disabled={true}
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Payment Method"
            value="VISA *************5671"
            disabled={true}
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Date of Purchase"
            value="2021-06-11"
            disabled={true}
          />
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>TRANSACTION DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3  mb-4">
          <TextInput
            label="Amount Received From Buyer"
            value="₹ 350"
            disabled={true}
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextInput label="Profit %" value="100" disabled={true} />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Courier Sip Date"
            value="2021-06-11"
            disabled={true}
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextInput label="Courier Partner" value="BlueDart" disabled={true} />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput label="Shipping Charge" value="₹ 180" disabled={true} />
        </div>
      </div>
      {successPopUp()}
      <ProductMedia
        url={image}
        isOpen={media}
        toggle={toggleMedia}
        onAdd={addImage}
        onDelete={deleteImage}
        onEdit={updateImage}
        isChange={state}
        data={donation}
        handleRefresh={handleRefresh}
      />
    </>
  );
};

export default EditDonation;
